let arrList = [
    {
        name: '随机卷轴*100',
        prize_img: require('../assets/images/g01.png'),
        prize_id: '1',
        order: 1
    },
    {
        name: '能量石*100',
        prize_img: require('../assets/images/g02.png'),
        prize_id: '2',
        order: 2
    },
    {
        name: '饼干*10',
        prize_img: require('../assets/images/g03.png'),
        prize_id: '3',
        order: 3
    },
    {
        name: '随机碎片',
        prize_img: require('../assets/images/g04.png'),
        prize_id: '4',
        order: 4
    },
    {
        name: '伊伊碎片',
        prize_img: require('../assets/images/r002.png'),
        prize_id: '10',
        order: 5
    },
    {
        name: '紫色皮肤*2',
        prize_img: require('../assets/images/g05.png'),
        prize_id: '5',
        order: 6
    },
    {
        name: '金色皮肤*1',
        prize_img: require('../assets/images/g06.png'),
        prize_id: '6',
        order: 7
    },
    {
        name: '钻石*400',
        prize_img: require('../assets/images/g07.png'),
        prize_id: '7',
        order: 8
    },
    {
        name: '随即紫装*2',
        prize_img: require('../assets/images/r003.png'),
        prize_id: '11',
        order: 9
    },
    {
        name: '钻石*200',
        prize_img: require('../assets/images/g08.png'),
        prize_id: '8',
        order: 10
    },
    {
        name: '30点券',
        prize_img: require('../assets/images/r001.png'),
        prize_id: '12',
        order: 11
    },
    {
        name: '金币*10000',
        prize_img: require('../assets/images/g09.png'),
        prize_id: '9',
        order: 12
    },
]

export default arrList


// WEBPACK FOOTER //
// ./src/data/prize.js